import { render, staticRenderFns } from "./level.vue?vue&type=template&id=60414344&scoped=true&"
import script from "./level.vue?vue&type=script&lang=js&"
export * from "./level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60414344",
  null
  
)

export default component.exports